// extracted by mini-css-extract-plugin
module.exports = {"detailTemplateTitle":"index_detailTemplateTitle__d_u2i"};